import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Catalog Section pages
export const CatalogSectionListPage = lazy(
  () =>
    retry(() => import('@pages/settings/catalog-sections/list')) as Promise<
      typeof import('@pages/settings/catalog-sections/list')
    >
);

export const CatalogSectionEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/catalog-sections/edit')) as Promise<
      typeof import('@pages/settings/catalog-sections/edit')
    >
);

export const CatalogSectionCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/catalog-sections/create')) as Promise<
      typeof import('@pages/settings/catalog-sections/create')
    >
);

export const PartnerSectionsPage = lazy(
  () =>
    retry(() => import('@pages/settings/catalog-sections/partners')) as Promise<
      typeof import('@pages/settings/catalog-sections/partners')
    >
);

export const ProductSectionsPage = lazy(
  () =>
    retry(() => import('@pages/settings/catalog-sections/products')) as Promise<
      typeof import('@pages/settings/catalog-sections/products')
    >
);
